import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import { useParams } from 'react-router-dom';
import styles from './Pod.module.css';
import { useCanvas } from '../../context/canvasContext';
import { PlusIcon, MinusIcon, FitIcon } from './icons';

const PodButton = ({ title, onClick, children }) => (
    <Tooltip title={title} placement="right">
        <button type="button" className={styles.button} onClick={onClick} aria-label={title}>{children}</button>
    </Tooltip>
);

/** The canvas zoom level, kept current across buttons, wheel and pinch (all of which re-render). */
const useZoomLevel = (canvasRef) => {
    const [zoom, setZoom] = useState(1);
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return undefined;
        const sync = () => setZoom(canvas.getZoom());
        sync();
        canvas.on('after:render', sync);
        return () => canvas.off('after:render', sync);
    }, [canvasRef]);
    return zoom;
};

/** Zoom in, out and reset; the current level shows in the reset tooltip. */
export const ZoomButtons = () => {
    const { id } = useParams();
    const { canvasRef, zoomIn, zoomOut, resetZoom } = useCanvas();
    const zoom = useZoomLevel(canvasRef);
    const level = `${Math.round(zoom * 100)}%`;

    return (
        <>
            <PodButton title="Zoom in" onClick={() => zoomIn(id)}><PlusIcon /></PodButton>
            <PodButton title="Zoom out" onClick={() => zoomOut(id)}><MinusIcon /></PodButton>
            <PodButton title={`Reset zoom (${level})`} onClick={resetZoom}><FitIcon /></PodButton>
        </>
    );
};

export default ZoomButtons;
